export interface ILegDetails {
    serviceRequestId: string,
    legId: string,
    statusName: string,
    origin: string,
    originAddress: string,
    originAddressLocation: string,
    originContact: string,
    destination: string,
    destinationAddress: string,
    destinationAddressLocation: string,
    destinationContact: string,
    tailNumber: string,
    transportType: string,
    plannedStartTime: string,
    plannedEndTime: string,
    originLatitude: string,
    originLongitude: string,
    destinationLatitude: string,
    destinationLongitude: string
    isAllCateringCompleted: boolean
}

export interface IDriverPositionInfoModel {
    isSourceVisited: boolean,
    driverCurrentPosition
}

export interface ILegDetailsToBeDeliver {
    previousLeg: ILegDetails,
    currentLeg: ILegDetails
}

export enum LegStatusNames {
    NOTSTARTED = "Not Started",
    ENROUTE = "Enroute",
    ONSCENE = "On-Scene",
    PICKEDUP = "Picked up",
    DROPPEDOFF = "Dropped Off",
    DRIVERDONE = "Driver Done",
    JOBDONE = "Job Done",
    ONBOARD = "On-board",
    WHEELSUP = "Wheels Up",
    LANDED = "Landed"
}

export enum TransportType {
    GROUND = "Ground",
    AIR = "Air"
}

export interface ILegLocationPayloadModel {
    Latitude: string;
    Longitude: string;
}

export interface IDistanceDuration {
    distance: string;
    duration: string;
}

export interface IAddListnerToInfowindowModle {
    infoWindowContent: string,
    isAddEventListner: boolean,
    function: any
}
